import { TextField,  Toolbar, Menu, MenuItem, IconButton } from "@mui/material";
import { EditorContent, useEditor, FloatingMenu, EditorContext } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { useRef } from "react";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { HeadingButton } from "@/components/tiptap-ui/heading-button";
import { MarkButton } from "@/components/tiptap-ui/mark-button";
import { TextColorPopover } from "@/components/tiptap-ui/text-color-popover";
import Color from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import Link from "@tiptap/extension-link";
import { LinkButton, LinkPopover } from "@/components/tiptap-ui/link-popover";
import Highlight from "@tiptap/extension-highlight";
const tagReplacements = {
  'b': 'strong',
  'c': 'span style="color: #ecbf3e"',
  's': 'span style="font-size: 12px"',

}

const addMark = (color: string, text: string) => `<mark style=\"background-color: ${color}; color: inherit\">${text}</mark>`



export const AloveTextField = ({
  value,
  onChange,
  noBorders = false
} : {
  value: string;
  onChange: (value: string) => void;
  noBorders?: boolean;
}) => {
  const toolbarRef = useRef<HTMLDivElement>(null);
  const _value = `<p>${value}</p>`
  const editor = useEditor({
    extensions: [
      StarterKit,
      Color.configure({ types: ["textStyle"] }),
      TextStyle,
      Link.configure({ openOnClick: false, HTMLAttributes: {
        target: null,
        rel: null,
      } }),
      Highlight.configure({ multicolor: true })
    ],
    content: Object.keys(tagReplacements).reduce((acc, key) => {
      return acc.replace(new RegExp(`<${key}>(.*?)<\/${key}>`, 'g'), `<${tagReplacements[key]}>$1</${tagReplacements[key]}>`);
    }, _value)
    
    .replace(/\\n/g, '<br />')
    .replace(/(?<=>)([^<]*?)(%s)([^<]*?)(?=<)/g, (match, before, target, after) => before + addMark('#81ff68', target) + after)
    .replace(/(?<=>)([^<]*?)(@[A-Za-z0-9_]+)([^<]*?)(?=<)/g, (match, before, target, after) => before + addMark('#ff85cf', target) + after)
    .replace(/(?<=>)([^<]*?)(~[A-Za-z0-9_]+)([^<]*?)(?=<)/g, (match, before, target, after) => before + addMark('#c70070', target) + after)
    .replace(/<a>/g, '<a href="aa">'),
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      const replacedHtml = Object.keys(tagReplacements).reduce((acc, key) => {
        return acc.replace(new RegExp(`<${tagReplacements[key]}>(.*?)<\/${tagReplacements[key]}>`, 'g'), `<${key}>$1</${key}>`);
      }, html)
      .replace(/<br \/>/g, '\\n')
      .replace(/<mark (.*?)>(.*?)<\/mark>/g, '$2')
      .replace(/<p>(.*?)<\/p>/g, '$1')
      onChange(replacedHtml);
    },
  });
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handlePlusClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <EditorContext.Provider value={{ editor }}>
      {/* <Toolbar
        ref={toolbarRef}
      >
        {mobileView === "main" ? (
          <MainToolbarContent
            onHighlighterClick={() => setMobileView("highlighter")}
            onLinkClick={() => setMobileView("link")}
            isMobile={isMobile}
            editor={editor}
          />
        ) : (
          <MobileToolbarContent
            type={mobileView === "highlighter" ? "highlighter" : "link"}
            onBack={() => setMobileView("main")}
          />
        )} 
      </Toolbar> */}
<div>
      <style>{`
        .mdinput-style {
          ${noBorders ? 'border: none;' : 'border: 1px solid rgba(49, 49, 54, 1);'}
          border-radius: 6px;
          font-size: 14px;
          padding: 12px;
          background: transparent;
          transition: border-color 0.2s;
          width: 100%;
        }
          .mdinput-style a {
            text-decoration: underline !important;
          }
        .floating-menu {
          background-color: #fff;
          border-radius: 6px;
          padding: 5px;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
          z-index: 1000;
          border: 1px solid rgb(0, 0, 0);
          display: flex;
          flex-direction: row;
        }
      `}</style>
      <EditorContent editor={editor} role="presentation" className="mdinput-style" />
      {editor && (
        <FloatingMenu
          editor={editor}
          tippyOptions={{ duration: 100 }}
          className="floating-menu"
        
          shouldShow={({ editor }) => {
            // Show only when text is selected
            return (
              editor.isActive("textStyle") ||
              (editor.state.selection.empty === false &&
                editor.state.selection.from !== editor.state.selection.to)
            );
          }}
        >
          <MarkButton type="bold" />
          <TextColorPopover
            editor={editor}
            colors={[
              {
                label: "Gold",
                value: "#ecbf3e",
              },
            ]}
          />
          <LinkPopover editor={editor} />
        </FloatingMenu>
      )}
      {/* <IconButton
        aria-label="add"
        onClick={handlePlusClick}
        style={{
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          background: "#f0f0f0",
          color: "#888",
          zIndex: 2,
        }}
        size="small"
      >
        <AddIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleMenuClose}>Example Action 1</MenuItem>
        <MenuItem onClick={handleMenuClose}>Example Action 2</MenuItem>
      </Menu> */}
      </div>
    </EditorContext.Provider>
  );
};
